export default __webpack_public_path__ + "static/1160-377e19e61c880519bb75856e199fb08d.gif";